import apiClient from '../lib/apiClient';

const probationLettersService = {
  // Get all probation letters
  getProbationLetters: async (filters = {}) => {
    try {
      const result = await apiClient.get('/probation-letters', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch probation letters' };
    }
  },

  // Get probation letter by ID
  getProbationLetter: async (id) => {
    try {
      const result = await apiClient.get(`/probation-letters/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch probation letter' };
    }
  },

  // Create probation letter
  createProbationLetter: async (data) => {
    try {
      const result = await apiClient.post('/probation-letters', data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create probation letter' };
    }
  },

  // Update probation letter
  updateProbationLetter: async (id, data) => {
    try {
      const result = await apiClient.put(`/probation-letters/${id}`, data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update probation letter' };
    }
  },

  // Delete probation letter
  deleteProbationLetter: async (id) => {
    try {
      const result = await apiClient.delete(`/probation-letters/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete probation letter' };
    }
  },

  // Download probation letter PDF
  downloadProbationLetter: async (id) => {
    try {
      const token = apiClient.getToken();
      const url = `${apiClient.baseURL}/probation-letters/${id}/download?token=${token}`;
      window.open(url, '_blank');
      return { success: true };
    } catch (error) {
      return { success: false, error: 'Failed to download probation letter' };
    }
  }
};

export default probationLettersService;

